import React from 'react';
import { Box, Typography } from '@mui/material';

import styles from './liveIndicator.module.scss';

export const LiveIndicator = () => (
  <Box className={styles.liveIndicator} data-testid="component-indicator-live">
    <Typography>Live</Typography>
  </Box>
);
